import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Auth } from "aws-amplify";
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Form } from "react-bootstrap";
import { Alert } from 'reactstrap';
import LoaderButton from "../components/LoaderButton";
import "./Login.css";

var redirect = false; 

const schema = Yup.object({
  Email: Yup.string().required()
  .matches(/^[a-zA-Z0-9.!#$%&’'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/, 'Invalid email address'),
  Password: Yup.string().required()
});

export default class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isNewpasswordRequired: false,
      userObject: null,
      alertMessage: "",
      infoMessage: ""
    };

  }

  onDismiss = () => this.setState({ alertMessage: "", infoMessage: "" });

  handleSubmit = async event => {

    this.setState({ isLoading: true, alertMessage: "", infoMessage: "" });

    try {
      const user = await Auth.signIn(event.Email, event.Password);
      if (user.challengeName === 'NEW_PASSWORD_REQUIRED') { 
        if (this.state.isNewpasswordRequired) {
          await Auth.completeNewPassword(this.state.userObject, event.NewPassword);
          this.setState({ isNewpasswordRequired: false, userObject: null, isLoading: false, infoMessage: "" });
          this.props.userHasAuthenticated(true);
        } else {
          this.setState({ isNewpasswordRequired: true, userObject: user, isLoading: false, infoMessage: "Please change your password." });
        }
      } else {
        this.props.userHasAuthenticated(true);
      }
    } catch (e) {
      var message = e.message;
      if (e.code == "UserNotConfirmedException") {
        message = "";
        this.props.emailAddressHandler(event.Email);
        this.props.history.push("/login/verify");
      }
      if (e.code == "NotAuthorizedException" && message == "") {
        message = "";
      }
      this.setState({ isLoading: false, alertMessage: message, infoMessage: "" });
    }
  }

  render() {
    return (
      <div className="login">
      <Formik
      validateOnChange={false}
      validationSchema={schema}
      onSubmit={this.handleSubmit}
      initialValues={{
        Email: '',
        password: '',
      }}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
      }) => (
      <div>
        <Alert color="warning" isOpen={!this.state.alertMessage == ""} toggle={this.onDismiss} fade={false}>
          <h4 className="alert-heading">Error</h4>
          <p>{this.state.alertMessage}</p>
        </Alert>
        <Alert color="info" isOpen={!this.state.infoMessage == ""} toggle={this.onDismiss} fade={false}>
          <h4 className="alert-heading">Information</h4>
          <p>{this.state.infoMessage}</p>
        </Alert>
        <div className="content">
          <h2>DataStar Login</h2>
          <div>Login to view and manage your DataStar License keys. If you have not previously regstered please use the registration button.</div>
          <div>If your organisation is not registered please contact <a href = "mailto: sales@absolute.technology">sales@absolute.technology</a></div>
        </div>
        <Form noValidate onSubmit={handleSubmit}>
          <Form.Group controlId="formBasicEmail">
            <Form.Label>Email</Form.Label>
            <Form.Control className="form-control-sm"
              name="Email"
              value={values.Email}
              placeholder="Enter email"
              type="email"
              onChange={handleChange}
              isInvalid={!!errors.Email}
            />
            <Form.Control.Feedback type="invalid">
                {errors.Email}
            </Form.Control.Feedback>
          </Form.Group>
          { !this.state.isNewpasswordRequired ? <div>
          <Form.Group controlId="formBasicPassword">  
            <Form.Label>Password</Form.Label>
            <Form.Control className="form-control-sm"
              name="Password"
              value={values.Password}
              placeholder="Password"
              onChange={handleChange}
              isInvalid={!!errors.Password}
              type="password"
            /> 
            <Form.Control.Feedback type="invalid">
                {errors.Password}
            </Form.Control.Feedback>
            <Form.Text className="text-muted">
              <Link Style={"font-size: 1em;"} to="/login/reset">Forgot password?</Link>
            </Form.Text>
          </Form.Group> 
          </div>  : <span/> }
          { this.state.isNewpasswordRequired ? <div>
          <Form.Group controlId="newPassword">
            <Form.Label>New Password</Form.Label>
            <Form.Control className="form-control-sm"
              name="NewPassword"
              value={values.newPassword}
              placeholder="New Password"
              type="password"
              onChange={handleChange}
              isInvalid={!!errors.newPassword}
            />
            <Form.Control.Feedback type="invalid">
              {errors.newPassword}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId="confirmPassword">  
            <Form.Label>Confirm Password</Form.Label>
            <Form.Control className="form-control-sm"
              name="ConfirmPassword"
              value={values.confirmPassword}
              placeholder="Confirm Password"
              onChange={handleChange}
              isInvalid={!!errors.confirmPassword}
              type="password"
            />
            <Form.Control.Feedback type="invalid">
                {errors.confirmPassword}
            </Form.Control.Feedback>
          </Form.Group></div>
          : <span/> }
          <div className="buttons">
        <LoaderButton
            span
            type="submit"
            isLoading={this.state.isLoading}
            text="Login"
            loadingText="Logging in…"
          />
          <Link to="/register" className="float-right btn btn-primary btn-dark btn-sm" disabled={this.state.isLoading}>
            Register
          </Link>
        </div>
        </Form>
      </div>
       )}
      </Formik>
      </div>
    );
  }
}
